import ThemeManager from "project-config/services/theme-manager";
ThemeManager.init();
const newTheme = ThemeManager.newTheme;

export enum FrameType {
  Prepare = 1,
  Photon = 2,
  MergePhoton = 3,
  PriorityRender = 4,
  Render = 5,
  PriorityRenderMerge = 6,
  RenderMerge = 7,
  GopHoudini = 8,
  MaxChannel = 9,
  DistributedHoudini = 10,
  DistributedHoudiniMaster = 11,
  AdditionalFeature = 15,
  MayaSimulation = 16,
  GIAdditionalFeature = 17,
  MergeGIAdditionalFeature = 18,
}

export enum FrameStatus {
  /** 等待中 */
  Waiting = 1,
  /** 渲染中 */
  Rendering = 2,
  /** 停止 */
  Stop = 3,
  /** 已完成 */
  Done = 4,
  /** 失败 */
  Failed = 5,
  /** 等待预处理完成 */
  WaitingForPreprocessingDone = 6,
  /** 等待光子帧渲染完成 */
  WaitingForPhotonFramesDone = 7,
  /** 等待优先渲染完成 */
  WaitingForTestFramesDone = 8,
  /** 等待光子作业渲染完成 */
  WaitingForPhotonJobDone = 9,
  /** 等待解算作业渲染完成 */
  WaitingForSimulationDone = 10,
  /** 超时停止 */
  TimeoutStop = 11,
  /** 副帧等待中 */
  WaitingSubFrame = 12,
  /** 预备中 */
  RenderPreparation = 14,
}

export const AdditionalFrameTypeList = [
  FrameType.AdditionalFeature,
  FrameType.GIAdditionalFeature,
  FrameType.MergeGIAdditionalFeature,
];

export const WaitingAndRenderingTasks = [
  FrameStatus.Waiting,
  FrameStatus.Rendering,
  FrameStatus.RenderPreparation,
  FrameStatus.WaitingForPreprocessingDone,
  FrameStatus.WaitingForPhotonFramesDone,
  FrameStatus.WaitingForPhotonJobDone,
  FrameStatus.WaitingForSimulationDone,
];

export const StopedTasks = [FrameStatus.Stop, FrameStatus.TimeoutStop];

export const mayaPhotonTasks = [
  FrameStatus.WaitingForPreprocessingDone,
  FrameStatus.WaitingForPhotonFramesDone,
  FrameStatus.WaitingForPhotonJobDone,
  FrameStatus.WaitingForSimulationDone,
];

export const WiatForRenderingTasks = [
  FrameStatus.WaitingForPreprocessingDone,
  FrameStatus.WaitingForSimulationDone,
];

export const FrameStatusRadiusMap = new Map<FrameStatus, FrameStatus[]>([
  [FrameStatus.Waiting, [FrameStatus.Waiting]],
  [FrameStatus.Rendering, [FrameStatus.Rendering]],
  [FrameStatus.Stop, [FrameStatus.Stop]],
  [FrameStatus.Done, [FrameStatus.Done]],
  [FrameStatus.Failed, [FrameStatus.Failed]],
  [
    FrameStatus.WaitingForPreprocessingDone,
    [FrameStatus.WaitingForPreprocessingDone],
  ],
  [
    FrameStatus.WaitingForPhotonFramesDone,
    [FrameStatus.WaitingForPhotonFramesDone],
  ],
  [
    FrameStatus.WaitingForTestFramesDone,
    [FrameStatus.WaitingForTestFramesDone],
  ],
  [FrameStatus.WaitingForPhotonJobDone, [FrameStatus.WaitingForPhotonJobDone]],
  [
    FrameStatus.WaitingForSimulationDone,
    [FrameStatus.WaitingForSimulationDone],
  ],
  [FrameStatus.TimeoutStop, [FrameStatus.TimeoutStop]],
  [FrameStatus.WaitingSubFrame, [FrameStatus.WaitingSubFrame]],
  [FrameStatus.RenderPreparation, [FrameStatus.RenderPreparation]],
]);

export const FrameStatusColorMap = new Map<FrameStatus, any>([
  [FrameStatus.Waiting, newTheme!["blue-1"]],
  [FrameStatus.Rendering, newTheme!["blue-1"]],
  [FrameStatus.Stop, newTheme!["orange-1"]],
  [FrameStatus.Done, newTheme!["green-2"]],
  [FrameStatus.Failed, newTheme!["red-1"]],
  [FrameStatus.WaitingForPreprocessingDone, newTheme!["blue-1"]],
  [FrameStatus.WaitingForPhotonFramesDone, newTheme!["blue-1"]],
  [FrameStatus.WaitingForTestFramesDone, newTheme!["blue-1"]],
  [FrameStatus.WaitingForPhotonJobDone, newTheme!["blue-1"]],
  [FrameStatus.WaitingForSimulationDone, newTheme!["blue-1"]],
  [FrameStatus.TimeoutStop, newTheme!["orange-1"]],
  [FrameStatus.WaitingSubFrame, newTheme!["blue-1"]],
  [FrameStatus.RenderPreparation, newTheme!["blue-1"]],
]);
